import { createReducer, on, Action } from '@ngrx/store';
import {
  ApiError,
  GetCustomerApplicantsResponse,
} from '../../client/src/models';
import { LoadState } from '@nx-ng/types';
import { CustomerStoreActions } from '../../actions';
import { ICustomerStateCustomer } from '../../types';

export interface ICustomerState {
  customer: ICustomerStateCustomer;
  customerApplicants: {
    applicants?: GetCustomerApplicantsResponse;
    loaded: LoadState;
    error?: string | ApiError;
  };
}

export const initialState: ICustomerState = {
  customer: {
    loaded: LoadState.NOT_LOADED,
    updated: LoadState.NOT_LOADED,
  },
  customerApplicants: {
    loaded: LoadState.NOT_LOADED,
  },
};

const dataAccessCustomerDetailsReducer = createReducer(
  initialState,
  on(CustomerStoreActions.loadDataAccessCustomerDetails, (state) => {
    return {
      ...state,
      customer: {
        ...state.customer,
        loaded: LoadState.LOADING,
        loadError: undefined,
      },
    };
  }),
  on(
    CustomerStoreActions.loadDataAccessCustomerDetailsSuccess,
    (state, { loadedCustomer: customer }) => ({
      ...state,
      customer: {
        ...state.customer,
        details: customer,
        loaded: LoadState.LOADED,
        loadError: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.loadDataAccessCustomerDetailsFailure,
    (state, { error }) => ({
      ...state,
      customer: {
        ...state.customer,
        loaded: LoadState.FAILED,
        loadError: error,
      },
    })
  ),
  on(CustomerStoreActions.loadDataAccessCustomerDetailsNotFound, (state) => ({
    ...state,
    customer: {
      ...state.customer,
      loaded: LoadState.LOADED,
    },
  })),
  on(
    CustomerStoreActions.customerAPI_CreateCustomer,
    (state, { customerToCreate: customer }) => ({
      ...state,
      customer: {
        ...state.customer,
        updated: LoadState.LOADING,
        updateError: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_CreateCustomerSuccess,
    (state, { createdCustomer: customer }) => ({
      ...state,
      customer: {
        ...state.customer,
        details: customer,
        updated: LoadState.LOADED,
        updateError: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_CreateCustomerFailure,
    (state, { error }) => ({
      ...state,
      customer: {
        ...state.customer,
        updated: LoadState.FAILED,
        updateError: error,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_UpdateCustomer,
    (state, { customerToUpdate: customer }) => ({
      ...state,
      customer: {
        ...state.customer,
        updated: LoadState.LOADING,
        updateError: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_UpdateCustomerSuccess,
    (state, { updatedCustomer: customer }) => ({
      ...state,
      customer: {
        ...state.customer,
        details: customer,
        updated: LoadState.LOADED,
        updateError: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_UpdateCustomerFailure,
    (state, { error }) => ({
      ...state,
      customer: {
        ...state.customer,
        updated: LoadState.FAILED,
        updateError: error,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_loadBillingCustomerApplicants,
    (state) => ({
      ...state,
      customerApplicants: {
        applicants: undefined,
        loaded: LoadState.LOADING,
        error: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_loadBillingCustomerApplicantsSuccess,
    (state, { applicants }) => ({
      ...state,
      customerApplicants: {
        applicants,
        loaded: LoadState.LOADED,
        error: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_loadBillingCustomerApplicantsFailure,
    (state, { error }) => ({
      ...state,
      customerApplicants: {
        loaded: LoadState.FAILED,
        error,
      },
    })
  )
);

export function reducer(state: ICustomerState | undefined, action: Action) {
  return dataAccessCustomerDetailsReducer(state, action);
}
